import { css } from '@microsoft/fast-element';
export const foundationFilterStyles = css `
  .filter-wrapper {
    border: 1px solid gray;
    border-radius: calc(var(--design-unit) * 2px);
    padding: calc(var(--design-unit) * 1px);
  }

  .close-icon {
    display: flex;
    place-content: center;
    align-items: center;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    margin: calc(var(--design-unit) * 1px);
    padding: calc(var(--design-unit) * 1px);
    border: 1px solid transparent;
    border-radius: calc(var(--design-unit) * 2px);
    cursor: pointer;
  }

  .close-icon,
  .cloase-icon svg path {
    transition-property: all;
    transition-timing-function: linear;
    transition-duration: 300ms;
  }

  .close-icon:hover {
    border-color: red;
    background: rgb(255 0 0 / 25%);
  }

  .close-icon:hover svg path {
    fill: red;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    align-items: center;
  }

  .flex-row zero-text-field,
  .flex-row zero-select,
  .flex-row foundation-text-field,
  .flex-row foundation-select {
    flex: 1;
  }
`;
